import ErrorModal, { IErrorModalProps } from '@sunbit-dev/ui/src/components/ui/errorModal/ErrorModalx';
import * as commonActions from '../actions/commonActions';
import { ActionTypes } from '../models/actions/common';
import React from 'react';
import { selectError } from '../selectors';
import { useSelector, useDispatch } from 'react-redux';
import { replace } from 'connected-react-router';
import URLS from '../constants/urls';
import { ButtonColor } from '@sunbit-dev/ui/src/components/ui/button/Button';
import { ERROR_CODES } from '../errors/errors';
import { handleVerification } from '../actions/verificationActions';

const ErrorHandlerContainer: React.FC = () => {
  const error = useSelector(selectError);
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (error.isPage) {
      dispatch(replace(URLS.error));
    }
    if (error.code === ERROR_CODES.cardApplicationVerification) {
      dispatch(handleVerification());
    }
  }, [dispatch, error]);

  const submit = React.useCallback(() => {
    switch (error.submitActionType) {
      case ActionTypes.ClearState:
        return dispatch(commonActions.clearState());
      case ActionTypes.continueExistingApplicationWithConsumerAlert:
        dispatch(commonActions.continueExistingApplicationWithConsumerAlert());
        break;
    }
  }, [error.submitActionType, dispatch]);

  const errorProps: IErrorModalProps = {
    title: error.title as string,
    description: error.description as string,
    button: error.buttonTitle as string,
    buttonColor: ButtonColor.primaryLightBlue,
    isOpen: error.isModal && error.show,
    errorCode: error.code as string,
    payload: error.payload,
    submit,
  };
  if (error.isPage) {
    return null;
  }
  return <ErrorModal {...errorProps} />;
};

export default ErrorHandlerContainer;
